// Application configuration

// Detect if running locally based on the browser's current hostname
const isLocalhost = typeof window !== 'undefined' && 
  (window.location.hostname === 'localhost' || 
   window.location.hostname === '127.0.0.1');

const appConfig = {
  // API Configuration
  api: {
    baseUrl: isLocalhost 
      ? 'https://localhost:7085'
      : 'https://pelegoal-api-c5f3djanh4evbhe9.westeurope-01.azurewebsites.net',
  },
  // External URLs
  urls: {
    mainSite: 'https://www.pelegoal.com/',
    signOff: 'https://iam.pelegoal.com/sign-off',
  },
  // Authentication
  auth: {
    cookieName: 'UserId',
  },
};

export default appConfig;

